import { bool, array, string, func, oneOfType } from 'prop-types'
import { PureComponent } from 'react'
import { registerHotKey, unregisterHotKey } from '../utils'

class HotKey extends PureComponent {
  componentDidMount = () => {
    registerHotKey(this.props.hotKey, this.doCallback)
  }

  componentWillUnmount = () => {
    unregisterHotKey(this.props.hotKey)
  }

  doCallback = (e) => {
    this.props.callback(e)

    // Defaults to true. Returning false will override the browser's default behavior
    return !this.props.overrideBrowser
  }

  render() {
    return null
  }
}

HotKey.propTypes = {
  callback: func.isRequired,
  hotKey: oneOfType([array, string]).isRequired,
  overrideBrowser: bool,
}

export default HotKey
